import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FF3E12",
      "fill-rule": "evenodd",
      d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12m-12 1.414L7.374 18.04 5.96 16.626 10.586 12 5.96 7.374 7.374 5.96 12 10.586l4.626-4.626 1.414 1.414L13.414 12l4.626 4.626-1.414 1.414z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }